export const normalizeImageUrl = (imageUrl?: string) =>
    imageUrl?.replace(
        /\/(thumbs|preview|multithumb|minithumb|listthumb|gallery|medium|small-fit|medium-fit|large-fit|landscape|portrait)\//,
        '/{format}/'
    );
